import {setupConsoleForDebug} from "@/js/utils/setupConsoleForDebug";
import {smoothScrollByHash} from "@/js/utils/smoothScroll";
import {hashChangeController} from "@/js/controllers/hashChangeController";
import {useAppConfig} from "@/js/composables/useAppConfig";
import {mountVueComponentToElement} from "@/js/vue/mount/mountVueComponentToElement";
import {useKonamiIdLoginState} from "@/js/composables/useKonamiIdLoginState";
import '@/js/vue/modal';
import PageTop from "@/js/vue/components/PageTop.vue";
import UserGold from "@/js/vue/components/UserGold.vue";
import HeaderMaintenanceInfo from "@/js/vue/components/HeaderMaintenanceInfo.vue";
import ButtonKonamiIdLogin from "@/js/vue/components/ButtonKonamiIdLogin.vue";
import {initDrawerMenu} from "@/js/vue/drawer-menu/init";
import DrawerMenuContent from "@/js/vue/components/DrawerMenuContent.vue";
import {registerDrawerMenuHandler} from "@/js/vue/drawer-menu/eventHandler";
import {initEventDelegation} from '@/js/init/initEventDelegation';

const appConfig = useAppConfig();
const config = appConfig.config;

// 本番環境などではコンソールを表示したくない
setupConsoleForDebug(appConfig.isDebug)

/**
 * サービスヘッダー
 * */
const mountServiceHeader = () => {
    if (config.userGoldData !== null) {
        //ログイン済み
        const vm = mountVueComponentToElement('js-service_header-userinfo', UserGold, {props: {user: config.user, now: new Date(config.now)}});
        vm?.init?.(config.userGoldData);
    } else {
        mountVueComponentToElement("js-service_header-menu-login", ButtonKonamiIdLogin, {props: {loginUrl: config.urls.loginUrl}});
    }
};

/**
 * メンテナンス情報
 * */
const mountHeaderMaintenance = () => {
    const maintenance = config.maintenanceData?.maintenance ?? [];
    if (!maintenance.length || config.page === "error_503") return;
    mountVueComponentToElement('js-header-maintenance-info', HeaderMaintenanceInfo, {
        props: {
            maintenance: config.maintenanceData.maintenance,
            now: new Date(appConfig.now),
        }
    });
};

document.addEventListener("DOMContentLoaded", () => {
    mountServiceHeader();
    mountHeaderMaintenance();
    initDrawerMenu('js-drawer_menu',DrawerMenuContent);
    initEventDelegation(()=>{
        registerDrawerMenuHandler()
    });

    /**
     * page_top の表示を制御する vueインスタンス
     * ページをスクロールしてヘッダーが見えなくなったら「TOPへ戻る」ボタンを表示
     */
    mountVueComponentToElement('page_top', PageTop, {props: {targetSelector: 'div.konami_header'}})

    /**
     * ページ内のsmoothScrollを有効にする、location.hashに「#_～」がついていたら対象にスクロールする
     * */
    hashChangeController.setEvent({
        fn(hash) {
            smoothScrollByHash(hash);
        },
        first: 1000  // 既存仕様の #_xxx を初回表示時にも反映。初回発火の遅延をミリ秒で指定。
    });
});

const {unlock} = useKonamiIdLoginState();
// ブラウザバックを検知します
window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
        unlock();
    }
});
